import React from 'react';
import { useTranslation } from 'react-i18next';

import classnames from 'classnames';
import { parseEntities } from 'parse-entities';

import { HybridLink } from 'common/components';
import { IBreadcrumb } from 'common/interfaces/common.interfaces';

import { URLEnums } from 'enum/URLEnum';

import './Breadcrumbs.scss';

interface Props {
  links: IBreadcrumb[];
  pageName: string;
  className?: string;
  nullLinks?: boolean;
  nullLink?: string;
  nullTitle?: string;
}

export const Breadcrumbs = ({
  links,
  pageName,
  className,
  nullLinks = false,
  nullLink = '',
  nullTitle = '',
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <ul className="breadcrumbs">
        <li key="home" className="breadcrumbs-item">
          <HybridLink className={classnames('breadcrumbs-link', className)} to={t('/')}>
            {t('Home')}
          </HybridLink>
        </li>
        {links &&
          links.map((link) => {
            const title = link.field_short_title || link.title;
            const alias = title === 'Careers' ? t(URLEnums.Careers) : link.path.alias;

            return (
              <li key={title} className="breadcrumbs-item">
                <HybridLink className={classnames('breadcrumbs-link', className)} to={alias}>
                  {title}
                </HybridLink>
              </li>
            );
          })}
        {nullLinks && (
          <li className="breadcrumbs-item">
            <HybridLink className={classnames('breadcrumbs-link', className)} to={`${nullLink}`}>
              {nullTitle}
            </HybridLink>
          </li>
        )}
        <li className="breadcrumbs-item">{parseEntities(pageName)}</li>
      </ul>
    </div>
  );
};
